module.exports = __webpack_public_path__ + "static/img/rank_background2_official copy.e6077a90.png";